import React from "react";
import "./BannerComponent.css";
import Breadcrumb_comp from "../Breadcrumb_comp/Breadcrumb_comp";

const BannerComponent = (props) => {
  const data = [
    { name: "Home", link: "/home" }, // Example: Home link
    { name: props?.title }, // Last item (active breadcrumb)
  ];

  return (
    <section className="BannerComponent">
      <div className="container-fluid p-0">
        <div className="banner_img_holder">
          <img
            src={
              process.env.PUBLIC_URL +
              "/assets/Images/Visiting_Cards/Banner/banner_img_1.png"
            }
            // src={props?.img}
            className="banner_img"
            alt="Banner"
          />
        </div>
      </div>

      <div className="custom_container">
        <div className="banner_text_holder">
          <div className="Breadcrumb_div">
            <Breadcrumb_comp data={data} />
          </div>

          <div className="banner_heading_holder">
            <p className='banner_heading'>{props?.title}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannerComponent;
